import axios from "axios";
import { useState } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import "./App.css";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import Home from "./Pages/Home/Home";
import Quiz from "./Pages/Quiz/Quiz";
import Result from "./Pages/Result/Result";
import AdminAction from "./Pages/AdminAction/AdminAction";
import QuizCreation from "./Pages/QuizCreation/QuizCreation";
import QuizUpdate from "./Pages/QuizUpdate/QuizUpdate";
import Login from "./Pages/Login/Login";

import { decodeAnswer } from "./helpers/jwt";

function App() {
  const [questions, setQuestions] = useState();
  const [name, setName] = useState();
  const [score, setScore] = useState(0);
  const [section, setSection] = useState("");
  const [quiz, setQuiz] = useState("");
  const [timer, setTimer] = useState(0);
  const [activities, setActivities] = useState([]);
  const [correctQuestions, setCorrectQuestions] = useState([]);
  const [resultID, setResultID] = useState("");
  
  const getShuffledArr = arr => {
    if (arr.length === 1) {return arr};
    const rand = Math.floor(Math.random() * arr.length);
    return [arr[rand], ...getShuffledArr(arr.filter((_, i) => i !== rand))];
  };

  const fetchQuestions = async (fullName = "", quizId = "", yearSection = "", password = "") => {
    try {
      const { data } = await axios.post(`https://computer-quiz-backend.herokuapp.com/quizzes/${quizId}/auth`, {
        full_name: fullName,
        year_section: yearSection,
        password
      });
      const { data: { _id } } = await axios.post(`https://computer-quiz-backend.herokuapp.com/quizzes/${quiz}/results`, {
        full_name: fullName,
        year_section: yearSection,
        score: 999, // default score of pending
        activities
      });
      setResultID(_id);
      data.questions = data.questions.map(question => {
          question.correct_answer = decodeAnswer(question.correct_answer);
			    question.incorrect_answers = question.incorrect_answers.map(incorrect => decodeAnswer(incorrect))
          return question;
      });
      setQuestions(getShuffledArr(data.questions));
      const time = Number(data.time_limit) || 300; // default 5mins
      setTimer(time); // seconds
    } catch (e) {
      return {
        error: true,
        message: e?.response?.data
      }
    }
  };


  return (
    <BrowserRouter>
      <div className="app">
        <Header />
        <Switch>
          <Route path="/" exact>
            <Home
              name={name}
              setName={setName}
              fetchQuestions={fetchQuestions}
              section={section}
              setSection={setSection}
              quiz={quiz}
              setQuiz={setQuiz}
            />
          </Route>
          <Route path="/quiz">
            <Quiz
              name={name}
              timer={timer}
              questions={questions}
              score={score}
              setScore={setScore}
              setQuestions={setQuestions}
              activities={activities}
              setActivities={setActivities}
              correctQuestions={correctQuestions}
              setCorrectQuestions={setCorrectQuestions}
            />
          </Route>
          <Route path="/result">
            <Result
              name={name}
              score={score}
              quiz={quiz}
              section={section}
              activities={activities}
              correctQuestions={correctQuestions}
              resultID={resultID}
            />
          </Route>
          <Route path="/admin">
            <AdminAction/>
          </Route>
          <Route path="/admin-login">
            <Login/>
          </Route>
          <Route path="/admin-quiz" exact>
            <QuizCreation/>
          </Route>
          <Route path="/admin-quiz/:id" exact>
            <QuizUpdate/>
          </Route>
        </Switch>
      </div>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
